import { SVGProps } from "react";

export function FingerRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
      <path
        fill="currentColor"
        d="M224 320c0 17.69 14.33 32 32 32h64c17.67 0 32-14.31 32-32s-14.33-32-32-32h-64c-17.7 0-32 14.3-32 32zm43.6-64H352c17.67 0 32-14.31 32-32s-14.33-32-32-32h-80v40c0 8.5-1.7 16.5-4.4 24zm4.4-96h208c17.67 0 32-14.31 32-32s-14.33-32-32-32H271.2c.3 2.66.8 5.3.8 8v56zm48 256c0-17.69-14.33-32-32-32h-64c-17.67 0-32 14.31-32 32s14.33 32 32 32h64c17.7 0 32-14.3 32-32zm-117.9-60.2C196 345.6 192 333.3 192 320c0-5.766 1.08-11.24 2.51-16.55C157.4 300.6 128 269.9 128 232v-72.9c0-7.9 7.2-15.1 15.1-15.1s16.9 7.2 16 15.1v69.72c0 16.38 12.2 42.28 40.9 42.28c22.1 0 40-17 40-39.1V104c0-22.09-17.9-40-40-40h-63.4c-33.1 0-64.57 16-84.13 42.8l-26.45 36.4A136.277 136.277 0 0 0 0 223.3V312c0 75.1 60.89 136 136 136h32.88c-5.48-9.4-8.88-20.3-8.88-32c0-27.9 18-51.4 42.1-60.2z"
      ></path>
    </svg>
  );
}
